import type { FC } from 'react';

import { FormAsyncSelect, type IFormAsyncSelectProps } from '@procurify/ui'

export interface IRequesterFormSelectProps
  extends IFormAsyncSelectProps<Requester> {}

import { loadRequesters } from './RequesterSelect'
import { type Requester } from '../../models/Requester'

export const RequesterFormSelect: FC<IRequesterFormSelectProps> = (
  props
) => (
  <FormAsyncSelect<Requester>
    fullWidth={true}
    cacheOptions={true}
    isClearable={false}
    getOptionLabel={(option) => `${option.firstName} ${option.lastName}`}
    getOptionValue={(option) => (option.id ? option.id.toString() : null)}
    loadOptions={loadRequesters}
    {...props}
  />
)
